import * as types from '../actions/actionTypes'

function actionTypeEndsInSccuess(actionType) {
  return actionType.substring(actionType.length - 8) == '_SUCCESS';
}


const apiStatusReducer = (state = {
    apiCallsInProgess: 0,
}, action) => {

    if (action.type == types.BEGIN_API_CALL){
      state = {
        apiCallsInProgess: state.apiCallsInProgess = state.apiCallsInProgess + 1
      };
    } else if (action.type == types.ZERO_OUT_API_CALLS) {
      state = {
        apiCallsInProgess: 0
      };
    }else if (action.type == types.API_CALL_ERROR || actionTypeEndsInSccuess(action.type)){
      let tempApiCallsInProgress = state.apiCallsInProgess

      if (tempApiCallsInProgress > 0){
        tempApiCallsInProgress = tempApiCallsInProgress - 1
      } else {
        tempApiCallsInProgress = 0
      }

      state = {
        apiCallsInProgess: tempApiCallsInProgress
      };
    }
   
    
    return state;
};

export default apiStatusReducer;


// WEBPACK FOOTER //
// ./src/reducers/apiStatusReducer.js